import Vue from "vue";
import Adulticide from "../models/adulticide";

export const sprayPathStore = {
  state: () => ({
    adulticides: [],
    filteredAdulticides: [],
    filters: [],
    adulticidesOnMap: [],
    isLoading: true,
    dataLoaded: false,
    zones: [
      {
        name: "All Zones",
        id: null,
        points: [],
      },
    ],
    zonesFilter: null,
    viewingSessionDetails: null,
    selectedAdulticide: null,
    pathIndex: 0,
    pathDataPoint: null,
    onPathDataPointChange: null,
    settings: {
      displayFilterSettings: false,
      filters: {
        zones: {
          selectedZone: "All Zones",
          selectedZoneId: null,
          selectedZonesAsOverlay: false,
        },
        siteTypes: {
          "Spray Reminder": false,
          "No Spray": true,
        },
      },
    },
  }),

  getters: {
    checkedAdulticides(state) {
      const checkedFilter = ({ checked }) => checked;
      if (state.filters.length === 0) {
        return state.adulticides.filter(checkedFilter);
      }

      return state.adulticides.filter((adulticide) => {
        return (
          adulticide.checked &&
          state.filters.every((filter) => filter(adulticide))
        );
      });
    },
    filteredAdulticides(state) {
      if (state.filters.length === 0) return state.adulticides;

      return state.adulticides.filter((adulticide) => {
        return state.filters.every((filter) => filter(adulticide));
      });
    },
    isLoading(state) {
      return state.isLoading;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },

    mapAdulticides(state) {
      const checkedFilter = ({ checked }) => checked;
      const checkedAdulticides = state.adulticides.filter(checkedFilter);
      const adulticidesOnMap = state.zonesFilter
        ? checkedAdulticides.filter(state.zonesFilter)
        : checkedAdulticides;
      state.adulticidesOnMap = adulticidesOnMap;
      return adulticidesOnMap;
    },

    selectedAdulticideZone: (state) => {
      const {
        selectedZoneId,
        selectedZonesAsOverlay,
      } = state.settings.filters.zones;
      const zone = state.zones.find(({ id }) => id === selectedZoneId);
      const selectedZone = {
        ...zone,
        id: selectedZonesAsOverlay ? zone.id : null,
      };
      return selectedZone;
    },
  },

  mutations: {
    setZonesForSprayPaths(state, zones) {
      state.zones = [
        {
          name: "All Zones",
          id: null,
          points: [],
        },
        ...zones,
      ];
    },
    setIsLoading(state, value) {
      state.isLoading = value;
    },
    setDataLoaded(state, value) {
      state.dataLoaded = value;
    },
    setDisplayFilterSettings(state, displayFilterSettings) {
      state.settings.displayFilterSettings = displayFilterSettings;
    },
    checkAdulticide(state, { adulticide, checked }) {
      adulticide.checked = checked;
      let index = state.adulticides.findIndex((a) => a.id == adulticide.id);
      Vue.set(state.adulticides, index, adulticide);
    },

    clearAdulticides(state) {
      state.adulticides = [];
    },

    addAdulticide(state, json) {
      let adulticide = new Adulticide(json);

      if (!state.adulticides.some((a) => a.id === adulticide.id)) {
        state.adulticides.push(adulticide);
      }
    },

    deleteAdulticide(state, adulticideId) {
      let index = state.adulticides.findIndex((a) => a.id == adulticideId);
      Vue.delete(state.adulticides, index);
    },

    setAdulticideFilters(state, filters) {
      state.filters = filters;
    },

    setSelectedAdulticide(state, { adulticide, dontSetPathIndex }) {
      const currentSelection = state.selectedAdulticide;
      const newSelection = currentSelection === adulticide ? null : adulticide;
      state.selectedAdulticide = newSelection;
      state.adulticidesOnMap.forEach((adulticide) =>
        adulticide.onSelectedChanged(
          newSelection == null ? null : adulticide === newSelection
        )
      );
      if (currentSelection) {
        this.commit("clearPathDataPoint", currentSelection);
      }
      if (newSelection && !dontSetPathIndex) {
        this.commit("setPathIndex", { index: 0 });
      }
    },
    setPathIndex(state, { adulticide, index }) {
      if (adulticide && adulticide !== state.selectedAdulticide) {
        this.commit("setSelectedAdulticide", {
          adulticide,
          dontSetPathIndex: true,
        });
      }
      const newPathIndex = index;
      state.selectedAdulticide.requestSpraySessionEntries(
        (spraySessionEntries) => {
          const newDataPoint = spraySessionEntries[newPathIndex];
          state.pathDataPoint = newDataPoint;
          state.pathIndex = newPathIndex;
          if (state.selectedAdulticide.onPathDataPointChange) {
            state.selectedAdulticide.onPathDataPointChange(newDataPoint);
          }
        }
      );
    },
    increasePathIndex(state) {
      if (!state.selectedAdulticide) {
        return;
      }
      const index = state.pathIndex + 1;
      if (index >= state.selectedAdulticide.spraySessionEntriesTotal) {
        return;
      }
      this.commit("setPathIndex", { index });
    },
    decreasePathIndex(state) {
      if (!state.selectedAdulticide) {
        return;
      }
      const index = state.pathIndex - 1;
      if (index < 0) {
        return;
      }
      this.commit("setPathIndex", { index });
    },
    clearPathDataPoint(state, adulticide) {
      state.pathDataPoint = null;
      if (adulticide.onPathDataPointChange) {
        adulticide.onPathDataPointChange(null);
      }
    },
    applySprayPathFilterSettings(state, filters) {
      this.commit("setSelectedAdulticide", { adulticide: null });
      const { settings } = state;
      const zonesSettings = filters.zones;
      const selectedZone = state.zones.find(
        ({ name }) => name === zonesSettings.selectedZone
      );
      const selectedZoneId = selectedZone.id;
      settings.filters = filters;
      settings.filters.zones.selectedZoneId = selectedZoneId;

      if (!selectedZoneId) {
        state.zonesFilter = null;
      } else {
        state.zonesFilter = (mappable) => mappable.zone.id === selectedZoneId;
      }
    },
  },
};
